<template>
    <div class="draggable-fields">
        <div v-for="def in fieldDefs.modules" :key="def.key" class="field-module mb-2">
            <div class="accordion" role="tablist">
                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-0" role="tab">
                        <b-button 
                            block 
                            v-b-toggle="`${def.key}-accordion`" 
                            variant="light"
                            class="text-left"
                        >
                            {{ $t(def.title) }}
                        </b-button>
                    </b-card-header>
                    <b-collapse 
                        :id="`${def.key}-accordion`" 
                        :visible="def.key == 'input'" 
                        accordion="my-accordion" 
                        role="tabpanel"
                    >
                        <b-card-body class="p-2">
                            <draggable 
                                tag="div" 
                                class="fields-grid" 
                                :list="def.fields"
                                :clone="onClone"
                                :group="group"
                                @start="dragStart"
                                @end="dragEnd"
                                @change="change"
                                ghost-class="ghost"
                            >
                                <div 
                                    v-for="defField in def.fields" 
                                    :key="defField.key" 
                                    class="field-item"
                                >
                                    <template v-if="field !== null && (field.module == defField.field.module && field.type == defField.field.type)">
                                        <b-skeleton width="100%" height="60px" animation="throb" />
                                    </template>

                                    <b-card 
                                        v-else 
                                        class="field-card"
                                        no-body
                                    >
                                        <b-card-body class="p-2 d-flex flex-column align-items-center justify-content-center">
                                            <div class="field-icon mb-2">
                                                <b-icon :icon="defField.icon" font-scale="1.8" />
                                            </div>
                                            <div class="field-title text-center">
                                                {{ $t(defField.title) }}
                                            </div>
                                        </b-card-body>
                                    </b-card>
                                </div>
                            </draggable>
                        </b-card-body>
                    </b-collapse>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
import fieldDefs from "@/components/identityFields/defsv2"
import fieldObj from "@/components/identityFields/field"
import draggable from 'vuedraggable'
import IdentityFields from '@/components/identityFields/IdentityFields'

export default {
    name: 'DraggableFields',
    components: {
        draggable,
        IdentityFields
    },
    props: {
        group: {
            type: Object
        },

        mutateClone: {
            type: Function,
            default: (o) => o
        }
    },
    data: function() {
        return {
            draggingStarted: false,
            draggedElement: null
        }
    },

    methods: {
        onClone(original) {
            let fieldO = _.cloneDeep(fieldObj)

            const d = {
                ...fieldO,
                ...original.field,
            }

            return this.mutateClone(d)
        },

        dragStart(e) {
            this.draggingStarted = true
            this.draggedElement = e.item._underlying_vm_

            this.$emit('dragStart', e)
        },

        dragEnd(e) {
            this.draggingStarted = false
            this.draggedElement = null

            console.log("dragEnd", e)

            this.$emit('dragEnd', e)
        },

        change(e) {
            console.log("change", e)
        }
    },

    computed: {
        fieldDefs() {
            return fieldDefs
        },

        content: {
            get() {
                return this.value
            },

            set(val) {
                this.$emit('input', val)
            }
        },

        field() {
            return this.draggedElement
        }
    }
}
</script>

<style lang="scss" scoped>
.draggable-fields {
  .field-module {
    ::v-deep .card {
      border: 1px solid var(--border-color);
      border-radius: 6px;
      background: var(--card-bg);
    }
    
    ::v-deep .card-header {
      background: transparent;
      border-bottom: 1px solid var(--border-color);
      
      .btn {
        font-weight: 500;
        font-size: 0.875rem;
        padding: 0.75rem;
        color: var(--text-color);
        background: transparent;
        border: none;
        
        &:hover,
        &:focus,
        &:active {
          background: var(--hover-bg);
          color: var(--text-color);
          box-shadow: none;
        }
      }
    }
    
    .fields-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 0.5rem;
    }
    
    .field-item {
      .field-card {
        border: 1px solid var(--border-color);
        border-radius: 6px;
        cursor: grab;
        transition: all 0.15s ease;
        height: 100%;
        background: var(--card-bg);
        
        &:hover {
          border-color: transparent;
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
          transform: translateY(-2px);
          background: linear-gradient(135deg, var(--primary-start), var(--primary-end));
          
          ::v-deep .card-body {
            background: transparent;
          }
          
          .field-icon,
          .field-title {
            color: white !important;
          }
        }
        
        &:active {
          cursor: grabbing;
        }
        
        .field-icon {
          color: var(--text-muted);
          transition: color 0.15s ease;
        }
        
        .field-title {
          font-size: 0.75rem;
          color: var(--text-color);
          line-height: 1.2;
          font-weight: 500;
          transition: color 0.15s ease;
        }
      }
    }
  }
  
  .ghost {
    opacity: 0.5;
  }
}
</style>